var qty = 1;

$(function(){
    
    function getURLParameter(name) {
        return decodeURI(
            (RegExp(name + '=' + '(.+?)(&|$)').exec(location.search)||[,null])[1]
        );
    }
    
    var added_qty = getURLParameter('added-to-cart');
    if(added_qty > 0) {
        var title = $('#cart-popup header h4').html();
        if(added_qty == 1) {
            var new_title = getURLParameter('added-to-cart') + ' item added';
        } else {
            var new_title = getURLParameter('added-to-cart') + ' items added'
        }
        $('#cart-popup header h4').html(new_title);
        $('#cart-popup header').append('(' + title + ' in total)');
        show_cart_popup();
    }
    
    function show_cart_popup() {
        $("#cart_info .link").addClass('active');
        $("#cart-popup").slideDown(400);
    }
    
    function hidecart_popup() {
        $("#cart_info .link").removeClass('active');
        $("#cart-popup").slideUp(300);
    }
    var cart_popup_timout;
    if($('#cart-popup').length > 0) {
        $('#top').delegate(".checkout-link, #cart-popup","mouseenter",function(){
			clearTimeout(cart_popup_timout);
			cart_popup_timout = null;
        	//if(!($("#cart-popup").is(":visible"))){
                show_cart_popup();    			
    		//}    		
    	});
        $('html, .wrapper').click(function(){
            clearTimeout(cart_popup_timout);cart_popup_timout = null;
            hidecart_popup();
        });
        $('#cart-popup a.close').click(function(e){
            e.preventDefault();
            clearTimeout(cart_popup_timout);cart_popup_timout = null;
            hidecart_popup();
        });
    }
	
    $('#form-add-to-cart').submit(function(e) {
        e.preventDefault();
        //Disable the add button until this process is over
        $('#add').attr('disabled', 'disabled');
        //Qty
        
		qty = 1;
        var $qtyEl = jQuery('select[name="quantity"]');
        if($qtyEl.length > 0) {
            qty = $qtyEl.val();
        }
      console.log(qty);
		
		
		Shopify.queue = [];
		
		
		//Add the items to your cart
		$('input[name="id"], select[name="id"]').each(function(index, element) {
			var id = $(element).val(); console.log(id);
			Shopify.queue.push({
				variant_id: id,
				quantity: qty
			});
		});
		Shopify.moveAlong();
    });

	


});

Shopify.moveAlong = function() {
	console.log('moveAlong');
	// If we still have requests in the queue, let's process the next one.
	if (Shopify.queue.length) {
		var request = Shopify.queue.shift();
		Shopify.addItem(request.variant_id, request.quantity, Shopify.moveAlong);
	}
	// If the queue is empty, we will redirect to the cart page.
	else {
		refresh_page(qty);
	}
};

function refresh_page (qty) {
    if(window.location.search == "") {
      window.location = 'https://' + window.location.host + '/cart';
    } else {
        window.location = window.location.href + '&added-to-cart=' + qty;
    }
}
    
//Override
Shopify.onItemAdded = function(line_item) {
    //Adding to cart successful, update cart
    Shopify.getCart();    
}
//Override
Shopify.onCartUpdate = function(cart) {
    refresh_page (qty);
}
